import { Box, styled } from '@mui/material'
import VipPass from '@src/components/battle/demo/vip-pass/VipPassPage'
import BattleDemoSecNavBar from '@src/components/navigationBar/secondary/BattleDemoSecNavBar'
import { ROUTE } from '@src/constants/route'
import { BattlepassProvider } from '@src/contexts/battle/demo/BattlepassContext'
import { VipPassProvider } from '@src/contexts/battle/demo/VipPassContext'
import { useSecondaryNavBarContext } from '@src/contexts/share/SecondaryNavBarContext'
import BackGroundPNG from 'public/images/background-battle-demo-vip-pass.png'
import { useEffect } from 'react'

const Container = styled(Box)`
  width: 100vw;
  min-height: 100vh;

  background-image: url(${BackGroundPNG.src});
  background-size: cover;
  background-position: center;
  background-repeat: repeat;
`

const VipPassPage = () => {
  const { setupBar } = useSecondaryNavBarContext()

  useEffect(() => {
    setupBar(<BattleDemoSecNavBar route={ROUTE.BATTLE_DEMO_VIP_PASS} />)

    return () => setupBar(null)
  }, [setupBar])

  return (
    <BattlepassProvider>
      <VipPassProvider>
        <Container>
          <VipPass />
        </Container>
      </VipPassProvider>
    </BattlepassProvider>
  )
}

export default VipPassPage
